import { render } from "./AccountCreateEditFormComponent.vue?vue&type=template&id=9b44b1d6&scoped=true"
import script from "./AccountCreateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./AccountCreateEditFormComponent.vue?vue&type=script&lang=js"

import "./AccountCreateEditFormComponent.vue?vue&type=style&index=0&id=9b44b1d6&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b44b1d6"]])

export default __exports__